// store/partnerSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse } from '../models/model';
import { PartnerGetPaging } from '../services/partnerService';

interface PartnerState {
    items: any[];
    loading: boolean;
    error: string | null;
}

const initialState: PartnerState = {
    items: [],
    loading: false,
    error: null,
};

export const fetchPartners = createAsyncThunk(
    'partners/fetchAll',
    async () => {
        const response: ApiResponse = await PartnerGetPaging({});
        return response.result.items ;
    }
);

const partnerSlice = createSlice({
    name: 'partners',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchPartners.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPartners.fulfilled, (state, action) => {
                state.items = action.payload;
                state.loading = false;
            })
            .addCase(fetchPartners.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Lỗi không xác định';
            });
    },
});

export default partnerSlice.reducer;